import ParaPersonas from '@/components/Servicios/ServiciosPersonas/ParaPersonas'
import Personas from '@/components/Servicios/Personas'
import SeguroEducacion from '@/components/Servicios/ServiciosPersonas/SeguroEducacion'
import SeguroVida from '@/components/Servicios/ServiciosPersonas/SeguroVida'
import SeguroMascotas from '@/components/Servicios/ServiciosPersonas/SeguroMascotas'
import SeguroAccidentesPersonales from '@/components/Servicios/ServiciosPersonas/SeguroAccidentesPersonales'
import SeguroExequias from '@/components/Servicios/ServiciosPersonas/SeguroExequias'
import SeguroSalud from '@/components/Servicios/ServiciosPersonas/SeguroSalud'
import SeguroSoatMovilidad from '@/components/Servicios/ServiciosPersonas/seguroSoatMovilidad'
import SeguroPension from '@/components/Servicios/ServiciosPersonas/SeguroPension'
import PlanInversion from '@/components/Servicios/ServiciosPersonas/PlanInversion'
import FondoAhorro from '@/components/Servicios/ServiciosPersonas/FondoAhorro'
import SeguroHogar from '@/components/Servicios/ServiciosPersonas/SeguroHogar'
import SeguroAutos from '@/components/Servicios/ServiciosPersonas/SeguroAutos'
import SeguroMotos from '@/components/Servicios/ServiciosPersonas/SeguroMotos'
import Cuadro from '@/components/Servicios/ServiciosPersonas/Cuadro'

export default {
    path: 'personas/',
    component: ParaPersonas,
    children: [
        {
            path: '',
            component: Personas
        },
        {
            path: 'seguro-educación',
            component: SeguroEducacion
        },
        {
            path: 'seguro-vida',
            component: SeguroVida
        },
        {
            path: 'seguro-mascotas',
            component: SeguroMascotas
        },
        {
            path: 'seguro-accidentes-personales',
            component: SeguroAccidentesPersonales
        },
        {
            path: 'seguro-exequiales',
            component: SeguroExequias
        },
        {
            path: 'seguro-salud',
            component: SeguroSalud
        },
        {
            path: 'seguro-soat-movilidad',
            component: SeguroSoatMovilidad
        },
        {
            path: 'seguro-pension',
            component: SeguroPension
        },
        {
            path: 'plan-inversion',
            component: PlanInversion
        },
        {
            path: 'fondo-ahorro',
            component: FondoAhorro
        },
        {
            path: 'seguro-hogar',
            component: SeguroHogar
        },
        {
            path: 'seguro-arrendamiento',
            component: Cuadro
        },
        {
            path: 'seguro-autos',
            component: SeguroAutos
        },
        {
            path: 'seguro-motos',
            component: SeguroMotos
        }
    ]
}



// WEBPACK FOOTER //
// ./src/router/personas.js